

    // maximum safe integer (Math.pow(2, 53) - 1)
    // see: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer
    module.exports = 9007199254740991;





//////////////////
// WEBPACK FOOTER
// ./~/mout/number/MAX_SAFE_INTEGER.js
// module id = 1623
// module chunks = 0 1 2